import React from 'react';
import { motion } from 'framer-motion';
import { Wind, Activity, Anchor, MessageSquare, Home } from 'lucide-react';
const steps = [{
  id: 1,
  title: 'Freno',
  desc: 'Respiración 4-7-8',
  detail: 'Freno fisiológico inmediato para el sistema nervioso.',
  icon: Wind
}, {
  id: 2,
  title: 'Descarga',
  desc: 'Escaneo 30s',
  detail: 'Libera la tensión muscular que alimenta el pico de ansiedad.',
  icon: Activity
}, {
  id: 3,
  title: 'Regreso',
  desc: 'Anclaje',
  detail: 'Vuelve al presente físico con un gesto simple y discreto.',
  icon: Anchor
}, {
  id: 4,
  title: 'Corte',
  desc: 'Palabra Gatillo',
  detail: 'Interrumpe el bucle mental obsesivo al instante.',
  icon: MessageSquare
}, {
  id: 5,
  title: 'Seguridad',
  desc: 'Refugio 60s',
  detail: 'Señal de seguridad final para estabilizarte.',
  icon: Home
}];
export function ProtocolSection() {
  return <section className="py-24 bg-transparent px-4 relative z-10" data-id="element-327">
      <div className="max-w-5xl mx-auto" data-id="element-328">
        <div className="text-center mb-16" data-id="element-329">
          <span className="text-[#5BBFB5] font-semibold tracking-wider uppercase text-xs" data-id="element-330">
            El Mecanismo
          </span>
          <h2 className="text-3xl md:text-4xl font-semibold mt-3 mb-6 text-[#3A3A3A]" data-id="element-331">
            Protocolo 5-Min
          </h2>
          <p className="text-lg text-[#7A7A7A] max-w-2xl mx-auto font-light" data-id="element-332">
            Una secuencia diseñada biológicamente para desactivar la alarma.
          </p>
        </div>

        <div className="relative" data-id="element-333">
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-[1px] bg-[#E8E8E6] -z-10 transform -translate-y-1/2" data-id="element-334" />

          <div className="grid grid-cols-1 md:grid-cols-5 gap-8" data-id="element-335">
            {steps.map((step, index) => <motion.div key={step.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.8
          }} className="relative bg-white p-6 rounded-2xl border border-[#E8E8E6] flex flex-col items-center text-center group transition-all" data-id="element-336">
                <div className="w-12 h-12 rounded-full bg-[#F7F7F5] flex items-center justify-center mb-4 group-hover:bg-[#5BBFB5]/10 transition-colors duration-300" data-id="element-337">
                  <step.icon className="w-6 h-6 text-[#5BBFB5]" data-id="element-338" />
                </div>
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#5BBFB5] text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-339">
                  {index + 1}
                </div>
                <h3 className="font-semibold text-[#3A3A3A] mb-1" data-id="element-340">
                  {step.title}
                </h3>
                <p className="text-sm font-medium text-[#7A7A7A] mb-2" data-id="element-341">
                  {step.desc}
                </p>
                <p className="text-xs text-[#7A7A7A]/80 leading-relaxed font-light" data-id="element-342">
                  {step.detail}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}